module.exports = __webpack_public_path__ + "fonts/a28380d.eot";